import React from 'react';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ currentLang, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="flex items-center gap-2 px-4 py-2 rounded-md border border-[#C4B5A0] text-[#2C2C2C] hover:bg-[#C4B5A0] hover:text-white transition-all duration-300"
      aria-label="Toggle language"
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium uppercase tracking-wider">
        {currentLang === 'fr' ? 'EN' : 'FR'}
      </span>
    </button>
  );
};

export default LanguageToggle;
